<template>
<b-row class="item-details-container ">
  <b-col>
    <b-list-group-item>
      <a :href="'#option-details-'+option.id" draggable="false" class='wrapper-a' @click="clickToExpanding" >
        <b-row>
          <b-col class="px-0" cols="2" sm="1">
            <div class="toggle-icon"  @click.prevent>
              <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
              <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
            </div>
          </b-col>
          <b-col class="pl-0" cols="7" sm="9">
              <b-form-input v-model="updOption.name" @change="updateOption()"></b-form-input>
          </b-col>
          <b-col cols="1" class="pl-0 ml-0">
            <b-form-checkbox v-model="activeOption" switch @input="updateOption()">
              <span v-if="updOption.active==true">Active</span>
              <span v-else>Inactive</span>
            </b-form-checkbox>
          </b-col>
          <!-- <b-col cols="1">
            <a :href="'#'+$route.path">
              <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Option'" @click="confirmOptionDelete"></b-icon>
            </a>
          </b-col> -->
        </b-row>
      </a>

      <b-collapse   class="category-card" :id="'option-details-'+option.id" v-model="isVisible">
        <b-row class="pt-2">
          <b-col cols="2" sm="2">
            <label class="pt-1" for="u_add-price" style="float: right;">Extra Price: </label>
          </b-col>
          <b-col cols="4" sm="2">
            <b-form-input id="u_add_price" v-model="updOption.add_price" @change="updateOption()"></b-form-input>
          </b-col>
          <b-col cols="3" sm="2" class="px-0">
            <label for="select_qty" style="float: right;">Select qty: </label>
          </b-col>
          <b-col cols="3" sm="2">
            <b-form-input id="select_qty" v-model="updOption.select_qty" type="number" @change="updateOption()"></b-form-input>
          </b-col>
          <!-- <b-col cols="4">
            <b-form-group>
              <b-form-radio-group
                v-model="updOption.select_qty"
                :options="[{text: 'Pick multiple', value: 0},{text: 'Pick one only', value: 1}]"
                @change="updateOption()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row class="py-2">
          <b-col style="text-align:center;">
            <b-button variant="outline-danger" @click="confirmOptionDelete">Delete?</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5 style="text-align: center;" class="mt-2">Options - Choices</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-list-group>
              <draggable v-model="option.optionitems" @end="dragend" :options="{ forceFallback: true }">
                <OptionOptItems

                  v-for="optitem of option.optionitems"
                  v-bind:optitem="optitem"
                  v-bind:key="optitem.id"
                  :option_id="option.id"
                  @emit-refresh-optionitems="emitFetchOptions"
                  @emit-switch-overlay="emitSwitchOverlay">
                </OptionOptItems>
              </draggable>
              <!-- Datalist searching for items to add to category -->
              <b-list-group-item>
                <b-form-input v-model="optitemname" :list="'optitem-list'+option.id" placeholder="Search for choice" @update="fetchSearchOptItems()" @change="addOptionOptItem()"></b-form-input>
                <datalist :id="'optitem-list'+option.id">
                  <option v-for="optitem in optitems" :key="optitem.id">{{ optitem.name }}</option>
                </datalist>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-collapse>
    </b-list-group-item>
   </b-col>
  </b-row>
</template>

<script>
import OptionOptItems from '@/components/OptionOptItems.vue'
import draggable from 'vuedraggable';
export default {
  name: 'OptionList',
  components: {
    OptionOptItems,
    draggable
  },
  props: ['option'],
  data () {
    return {
      updOption: {
        name: this.option.name,
        add_price: this.option.add_price,
        select_qty: this.option.select_qty,
        active: this.option.active
      },
      optitems: [],
      optitemname: '',
      isVisible: false
    }
  },

  computed: {
    activeOption: {
      get: function() {
        return this.option.active;
      },
      set: function(newVal) {
        this.updOption.active = newVal;
      }
    },

    namefilter: function() {
      if (this.optitemname != '') {
        return '&name='+this.optitemname;
      } else {
        return '';
      }
    },
  },

  methods: {
    clickToExpanding(event){
      const currentIsVisible = this.isVisible ;
      const clickedTag = event.target.tagName ;
      const classTarget = event.target.classList[0];
      console.log(classTarget);
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON')
             || ( clickedTag.includes('svg') && (classTarget === "bi-x-circle"))
             || (classTarget ==="list-group-item"))
      {
         event.preventDefault();
        this.isVisible = currentIsVisible ;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }

    },
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitFetchOptions() {
      this.$emit('emit-fetch-options');
    },

    dragend() {
      var optitems = [];
      var i=1;
      for (const optitem of this.option.optionitems) {
        optitems.push({
          "option_item_id": optitem.id,
          "sort_order": i
        });
        i+=1;
      }
      optitems = {"optitem_sort": optitems}
      this.updateOptionOptItemSort(optitems);
    },

    async updateOptionOptItemSort(optitems) {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = optitems;
      // update order with status of 'ready'
      const { data } = await this.$api.patch('optionheaders/'+this.option.id+'/optionitems/sortorder',
        body,
        config
      );
      if (data.success == true) {
        this.emitSwitchOverlay(false);
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the sort order, please try again later.', {
          title: 'Error updating sort order',
          centered: true
        })
      }
    },

    async fetchSearchOptItems() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("optionitems?active=True&nothead="+this.option.id+this.namefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.optitems = await data.optionitems;
      // this.emitSwitchOverlay(false);
    },

    async addOptionOptItem() {
      // filter the optionitems for a match to the selected option item name, then select the relevant id
      const res = this.optitems.filter(i => i.name == this.optitemname);
      if (res == undefined) {
        return;
      } else {
        var optitem_id = res[0].id;
      }
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "optitem_id": optitem_id
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('optionheaders/'+this.option.id+'/optionitems',
        body,
        config
      );
      if (data.created == true) {
        this.emitSwitchOverlay(false);
        this.emitFetchOptions();
        this.optitemname = '';
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem adding the choice to the option, please try again later.', {
          title: 'Error updating option',
          centered: true
        })
      }
    },

    async confirmOptionDelete() {
      if (this.option.optionitems > 0) {
        // If yes, give them this message
        this.$bvModal.msgBoxOk('There are Choices associated with this Option. Please remove them before deleting, or consider setting Option to Inactive.', {
          title: 'Unable to Delete',
          centered: true
        })
      } else {
        // if not, get a confirmation before deleting
        this.confirmDel = ''
        this.$bvModal.msgBoxConfirm('Please confirm that you want to delete option '+this.option.name+'!', {
          title: 'Please confirm delete',
          centered: true
        })
        // Confirmed - you can delete the category now!
        .then(value => {
          this.confirmDel = value
          if (this.confirmDel == true) {
            this.deleteOption();
          }
        })
        // Error processing modal
        .catch(err => {
          console.log('an error has occurred. '+ err)
        })
      }
    },

    async updateOption() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.updOption.name,
        "add_price": this.updOption.add_price,
        "select_qty": this.updOption.select_qty,
        "active": this.updOption.active
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('optionheaders/'+this.option.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchOptions();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the option, please try again later.', {
          title: 'Error updating option',
          centered: true
        })
      }
    },

    async deleteOption() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('optionheaders/'+this.option.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchOptions();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the option, please try again later.', {
          title: 'Error deleting option',
          centered: true
        })
      }
    },

  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%);
  }

  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
